module.exports = __webpack_public_path__ + "img/LOADER-03.e7279620.gif";